import authReducer from './auth/reducer';
import userReducer from './user/reducer';
import timeslotReducer from './timeslot/reducer';
import maintenanceReducer from './maintenance/reducer';
import { combineReducers } from 'redux';

export default combineReducers({
	auth: authReducer,
	user: userReducer,
	timeslot: timeslotReducer,
	maintenance: maintenanceReducer,
});
